import styled from "styled-components";

export const HeaderImage = styled.img`
    width: 40px;
    margin-right: 12px;
    display: block;
`;
